import { render, staticRenderFns } from "./DataProcessorCandidatesDataForm.vue?vue&type=template&id=4b545a7a&scoped=true"
import script from "./DataProcessorCandidatesDataForm.vue?vue&type=script&lang=js"
export * from "./DataProcessorCandidatesDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b545a7a",
  null
  
)

export default component.exports